import { Card, CardContent, CardHeader, CardTitle } from "@rumbledirect/ui";

import { Content } from "@/components/layout/content";
import { Topbar } from "@/components/layout/topbar";
import { CreateUserPermissionForm } from "@/pages/admin/users/permissions/components/user-permissions-create";

export default function UserPermissionCreate() {
  return (
    <>
      <Topbar
        title="Toevoegen"
        breadcrumb={[{ title: "User Permissions", href: "/users/permissions" }]}
      />

      <Content>
        <Card>
          <CardHeader>
            <CardTitle>Basisinformatie</CardTitle>
          </CardHeader>
          <CardContent>
            <CreateUserPermissionForm />
          </CardContent>
        </Card>
      </Content>
    </>
  );
}
